export default "__VITE_ASSET__BpxiUvaZ__"